<script>
  import { onMount } from "svelte";

  export let data;
  export let year_filter;

  let map;
  let heatmapLayer;

  let drawnItems;
  let baseLayer;
  let set_zoom_switch = 6;
  let field_name = "tendenz_qty"; //tendenz_active_animals
  // let field_inner_radius = "animal_qty"

  function minimum_n(a, b) {
    if (a < b) {
      return a;
    }
    return b;
  }

  function radius_veraenderung(number) {
    var ret = 0;
    //bis 300 alles
    var eins = 0;
    var zwei = 0;
    var drei = 0;
    var vier = 0;

    // if(number > 500)
    //   console.log("number: ", number)

    ret = minimum_n(number, 300) / 10;
    eins = ret;
    // if(number > 500)
    //   console.log("eins: ", eins)

    if (number > 300) {
      ret = eins + minimum_n(number - 300, 300) / 60;
      zwei = ret;
      // if(number > 500)
      //   console.log("zwei: ", zwei)
    }

    if (number > 600) {
      ret = zwei + minimum_n(number - 600, 600) / 120;
      drei = ret;
      // if(number > 500)
      //   console.log("drei: ", drei)
    }

    if (number > 1200) {
      ret = drei + (number - 1200) / 135;
      vier = ret;
      // if(number > 500)
      //   console.log("vier: ", vier)
    }

    // if(number > 500)
    //   console.log("ret ende: ", ret)

    if (ret < 4) ret = 4;

    return ret;
  }

  function resetAndDrawMarkers() {
    let bounds = map.getBounds();

    if (map.hasLayer(drawnItems)) {
      map.removeLayer(drawnItems);
    }

    // drawnItems = new L.FeatureGroup();

    //     if(map.hasLayer(drawnItems)){
    //     // map.removeLayer(drawnFeatures); <-- this the wrong way
    //     drawnItems.eachLayer(
    //         function(l){
    //             drawnItems.removeLayer(l);
    //     });
    // }
    var lat_max = bounds["_northEast"]["lat"];
    var lng_max = bounds["_northEast"]["lng"];
    var lat_min = bounds["_southWest"]["lat"];
    var lng_min = bounds["_southWest"]["lng"];

    drawnItems.clearLayers();
    // drawnItems.clearMarkers();
    // clearMarkers(map)
    // clearMarkers(drawnItems)
    // clearGroup(map, drawnItems)

    var count_points = 0;

    // console.log('alle kunden: ', data);

    data.forEach(function (element) {
      if (
        element["partner_latitude"] > lat_min &&
        element["partner_latitude"] < lat_max &&
        element["partner_longitude"] > lng_min &&
        element["partner_longitude"] < lng_max
      ) {
        count_points = count_points + 1;
      }
    });

    // console.log("count_points: ", count_points)

    data.forEach(function (element) {
      // if(element['name'] == "Don Mclean Farm"){
      //   console.log("Don Mclean Farm: ", element)
      // }
      // if(element['partner_latitude'] > 54&& element['partner_latitude'] < 55&& element['partner_longitude'] > -8&& element['partner_longitude'] < -7){
      //   console.log("Irland: ", element)
      // }

      if (year_filter == "ALL") {
        if (element["active_animals"] == 0 && field_name == "tendenz_active_animals") {
          return;
        }
        if (element["animal_qty"] == 0 && field_name == "tendenz_qty") {
          return;
        }
      }

      if (
        element["partner_latitude"] > lat_min &&
        element["partner_latitude"] < lat_max &&
        element["partner_longitude"] > lng_min &&
        element["partner_longitude"] < lng_max
      ) {
        // console.log('element: ', element);
        var herd_coverage = element["active_animals"] / element["x_studio_herdengre_1"];
        // console.log('herd_coverage: ', herd_coverage);

        // var radius_outer = Math.log2(element['x_studio_herdengre_1'])*2.5
        // var radius_inner = Math.log2(element['active_animals'])*2.5

        var radius_outer = radius_veraenderung(element["x_studio_herdengre_1"]);
        var radius_inner;
        var active_animals;
        var charged_animals;

        if (year_filter == "ALL") {
          if (field_name == "tendenz_active_animals") {
            radius_inner = radius_veraenderung(element["active_animals"]);
          } else {
            radius_inner = radius_veraenderung(element["animal_qty"]);
          }

          active_animals = element["active_animals"];
          charged_animals = element["animal_qty"];
        } else {
          if (field_name == "tendenz_active_animals") {
            var key_name = "active_animals" + year_filter.toString();
            if (key_name in element) {
              radius_inner = radius_veraenderung(element[key_name]);
              active_animals = element[key_name];
              charged_animals = element["qty" + year_filter.toString()];
              if (active_animals == 0) {
                // console.log("return aa: ", element)
                return;
              }
            } else {
              return;
            }
          } else {
            var key_name = "qty" + year_filter.toString();
            if (key_name in element) {
              radius_inner = radius_veraenderung(element[key_name]);
              charged_animals = element[key_name];
              if (charged_animals == 0) {
                return;
              }
              active_animals = element["active_animals" + year_filter.toString()];
            } else {
              return;
            }
          }
        }

        // if(element['name'] == "Betrieb Johann Wiener"){
        //   console.log("Wallner: ", element)
        // }

        var text =
          "<b>" +
          element["name"] +
          "</b><br>" +
          "active animals: " +
          active_animals +
          " <br>" +
          "current herdcoverage: " +
          herd_coverage.toFixed(2) * 100 +
          "%<br>" +
          "herdsize: " +
          element["x_studio_herdengre_1"] +
          "<br>charged animals: " +
          charged_animals;

        if (herd_coverage < 0.2) {
          herd_coverage = 0.2;
        }

        var color = "CornflowerBlue";

        var tendenz_field_name;

        if (year_filter == "ALL") {
          tendenz_field_name = field_name;
          if (field_name == "tendenz_active_animals") {
            tendenz_field_name = "tendenz_active_animals";
          } else {
            tendenz_field_name = "tendenz_qty";
          }
        } else {
          if (field_name == "tendenz_active_animals") {
            tendenz_field_name = "tendenz_active_animals" + year_filter.toString();
          } else {
            tendenz_field_name = "tendenz_qty_" + year_filter.toString();
          }
        }

        if (element[tendenz_field_name] == 0) {
          color = "orange";
        }
        if (element[tendenz_field_name] == 1) {
          color = "DarkSeaGreen";
        }
        if (element[tendenz_field_name] == -1) {
          color = "IndianRed";
        }

        var circle_options = {
          radius: radius_outer,
          fillOpacity: 0,
          title: text,
          fillColor: "#FFFFFF",
          color: color,
        };
        L.circleMarker([element["partner_latitude"], element["partner_longitude"]], circle_options).addTo(drawnItems);

        circle_options = {
          radius: radius_inner,
          weight: 0,
          fillOpacity: herd_coverage,
          title: text,
          fillColor: color,
          color: color,
        };
        L.circleMarker([element["partner_latitude"], element["partner_longitude"]], circle_options).addTo(drawnItems);
      }
    });

    map.addLayer(drawnItems);
  }

  onMount(() => {
    baseLayer = L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}", {
      attribution:
        "Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012",
    });

    var cfg = {
      // radius should be small ONLY if scaleRadius is true (or small radius is intended)
      // if scaleRadius is false it will be the constant radius used in pixels
      radius: 15,
      maxOpacity: 0.8,
      // scales the radius based on map zoom
      scaleRadius: false,
      // if set to false the heatmap uses the global maximum for colorization
      // if activated: uses the data maximum within the current map boundaries
      //   (there will always be a red spot with useLocalExtremas true)
      useLocalExtrema: true,
      // which field name in your data represents the latitude - default "lat"
      latField: "lat",
      // which field name in your data represents the longitude - default "lng"
      lngField: "lng",
      // which field name in your data represents the data value - default "value"
      valueField: "count",
    };

    heatmapLayer = new HeatmapOverlay(cfg);
    drawnItems = new L.FeatureGroup();

    var smaXtecHQ = new L.LatLng(47.0592126, 15.4589642);

    map = new L.Map("leafletmap", {
      // Set some max bounds for the map
      // This causes the map to fling back when dragged out of bounds
      // Longitude bounds are overlapping at the Bering Strait
      // Centered on smaXtec HQ
      center: smaXtecHQ,
      zoom: 3,
      minZoom: 2,
      maxZoom: 18,
      maxBounds: [
        [-70, 201],
        [90, -179],
      ],
      layers: [baseLayer],
    });

    map.setView(smaXtecHQ, 3);

    // console.log('created Map Heat Layer');

    drawnItems.on("mouseover", function (e) {
      // ev.target.openPopup();
      // console.log("e: ", e)
      L.popup().setLatLng(e.sourceTarget._latlng).setContent(e.sourceTarget.options.title).openOn(map);
    });

    map.on("moveend", function () {
      var zoomlevel = map.getZoom();

      if (zoomlevel >= set_zoom_switch) {
        resetAndDrawMarkers();
      } else {
        if (map.hasLayer(drawnItems)) {
          map.removeLayer(drawnItems);
        }
      }
    });

    map.on("zoomend", function () {
      var zoomlevel = map.getZoom();

      // console.log('zoomlevel: ', zoomlevel);

      map.getBounds();
      // console.log('bounds: ', bounds);

      if (zoomlevel >= set_zoom_switch) {
        if (map.hasLayer(heatmapLayer)) {
          map.removeLayer(heatmapLayer);
        } else {
          // console.log('no heat layer active');
        }
      }
      if (zoomlevel < set_zoom_switch) {
        if (map.hasLayer(heatmapLayer)) {
          // console.log('heat already added');
        } else {
          map.addLayer(heatmapLayer);
        }
        if (map.hasLayer(drawnItems)) {
          map.removeLayer(drawnItems);
        }

        map.eachLayer(function (layer) {
          if (layer != baseLayer && layer != heatmapLayer) {
            map.removeLayer(layer);
          }
        });
      }
    });
  });

  $: {
    data, year_filter;
    let data_changed = data;

    if (data && year_filter) {
      // console.log('data in leafletmap: ', data);

      // var geo_data_from_res_partner = get_geo_data_from_res_partner(data_changed);
      let list_of_lat_and_long = [];

      map.eachLayer(function (layer) {
        if (layer != baseLayer) {
          map.removeLayer(layer);
        }
      });

      data_changed.forEach(function (element) {
        if (year_filter == "ALL") {
          if (field_name == "tendenz_active_animals") {
            // console.log("element['active_animals']: ", element['active_animals'])
            if (element["active_animals"] > 0) {
              list_of_lat_and_long.push({
                lat: element["partner_latitude"],
                lng: element["partner_longitude"],
                count: 1,
              });
            }
          } else {
            // console.log("element['animal_qty']: ", element['animal_qty'])
            if (element["animal_qty"] > 0) {
              list_of_lat_and_long.push({
                lat: element["partner_latitude"],
                lng: element["partner_longitude"],
                count: 1,
              });
            }
          }
        } else {
          if (field_name == "tendenz_active_animals") {
            var key_name = "active_animals" + year_filter.toString();
            if (key_name in element) {
              if (element[key_name] > 0) {
                list_of_lat_and_long.push({
                  lat: element["partner_latitude"],
                  lng: element["partner_longitude"],
                  count: 1,
                });
              }
            }
          } else {
            var key_name = "qty" + year_filter.toString();
            if (key_name in element) {
              // console.log("HIER")
              // console.log("element[key_name]: ", element[key_name])
              if (element[key_name] > 0) {
                list_of_lat_and_long.push({
                  lat: element["partner_latitude"],
                  lng: element["partner_longitude"],
                  count: 1,
                });
              }
            }
          }
        }
      });

      // console.log("list_of_lat_and_long: ", list_of_lat_and_long)

      let testData = {
        max: 8,
        data: list_of_lat_and_long,
      };

      heatmapLayer.setData(testData);

      if (map.getZoom() < set_zoom_switch) {
        map.addLayer(heatmapLayer);
      } else {
        resetAndDrawMarkers();
      }
    }
  }

  function use_active_animals() {
    // console.log("field_name_changed: ", s)
    field_name = "tendenz_active_animals";
    // field_inner_radius = "active_animals"
    data = data;
  }

  function use_qty() {
    // console.log("field_name_changed: ", s)
    field_name = "tendenz_qty";
    // field_inner_radius = "animal_qty"
    data = data;
  }
</script>

<div class="btn-group" role="group" aria-label="Basic example">
  <button type="button" on:click={use_qty} class="btn {field_name === 'tendenz_qty' ? 'active' : ''}"> Number of Charged Animals </button>
  <button type="button" on:click={use_active_animals} class="btn {field_name === 'tendenz_active_animals' ? 'active' : ''}">
    Active Animals
  </button>
</div>

<div id="leafletmap" />

<style>
  #leafletmap {
    height: 760px;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }
</style>
